// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"MessageBox_messageBox__27Tik"};